export default __webpack_public_path__ + "static/media/not-found.535d8b28.png";